import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import store from '@/store';
import { Storage } from "@/core/helpers/Storage";
import { Paths,Names } from '@/core/config/enums/SitePaths';
import Swal from "sweetalert2/dist/sweetalert2.js";

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		redirect: '/dashboard',
		component: () => import('@/layout/Layout.vue'),
		props: { key: Names.DASHBOARD },
		children: [
			{
				path: Paths.DASHBOARD,
				name: Names.DASHBOARD,
				component: () => import('@/views/Dashboard.vue'),
			},
			{
				path: Paths.DASHBOARD_V2,
				name: Names.DASHBOARD_V2,
				component: () => import('@/pages/dashboard/v2/AdminDashboardV2.vue'),
			},
			{
				path: Paths.MONITORING,
				name: Names.MONITORING,
				component: () => import('@/pages/monitoring/MonitoringPage.vue'),
			},
			{
				path: Paths.GOAL_TIMING,
				name: Names.GOAL_TIMING,
				component: () => import('@/pages/monitoring/GoalTimingPage.vue'),
			},
			
			{
				path: Paths.LEAGUES,
				name: Names.LEAGUES,
				meta:{

					key: Names.LEAGUES,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.LEAGUES}
			},
			{
				path: Paths.MARKETS,
				name: Names.MARKETS,
				meta:{
					key: Names.MARKETS,					
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.MARKETS}
			},
			{
				path: Paths.TEXT_CONSTANTS,
				name: Names.TEXT_CONSTANTS,
				meta:{
					key: Names.TEXT_CONSTANTS,					
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.TEXT_CONSTANTS}
			},
			{
				path: Paths.TEAMS,
				name: Names.TEAMS,
				meta:{

					key: Names.TEAMS,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.TEAMS}
			},
			{
				path: Paths.GAMES,
				name: Names.GAMES,
				meta:{

					key: Names.GAMES,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.GAMES}
			},
				{
				path: Paths.PURCHASES,
				name: Names.PURCHASES,
				meta: { key: Names.PURCHASES },
				component: () => import('@/pages/ListPage.vue'),
				props: { key: Names.PURCHASES },
			},

			{
				path: Paths.GENERAL_SETTINGS_EDIT,
				name: Names.GENERAL_SETTINGS_EDIT,
				meta:{

					key: Names.GENERAL_SETTINGS_EDIT,
				},
				component: () => import('@/pages/FormPage.vue'),
				props: {key:  Names.GENERAL_SETTINGS_EDIT}
			},
			{
				path: Paths.PLAYERS_OF_PERIOD_EDIT,
				name: Names.PLAYERS_OF_PERIOD_EDIT,
				meta:{
					key: Names.PLAYERS_OF_PERIOD_EDIT,
				},
				component: () => import('@/pages/FormPage.vue'),
				props: {key: Names.PLAYERS_OF_PERIOD_EDIT}
			},
			{
				path: Paths.HOME_HIGHLIGHTS_V2_EDIT,
				name: Names.HOME_HIGHLIGHTS_V2_EDIT,
				meta:{
					key: Names.HOME_HIGHLIGHTS_V2_EDIT,
				},
				component: () => import('@/pages/FormPage.vue'),
				props: {key: Names.HOME_HIGHLIGHTS_V2_EDIT}
			},
			{
				path: Paths.REWARD_SETTINGS_EDIT,
				name: Names.REWARD_SETTINGS_EDIT,
				meta:{

					key: Names.REWARD_SETTINGS_EDIT,
				},
				component: () => import('@/pages/FormPage.vue'),
				props: {key:  Names.REWARD_SETTINGS_EDIT}
			},
			{
				path: Paths.NOTIFICATIONS_ADD,
				name: Names.NOTIFICATIONS_ADD,
				meta:{

					key: Names.NOTIFICATIONS_ADD,
				},
				component: () => import('@/pages/FormPage.vue'),
				props: {key:  Names.NOTIFICATIONS_ADD}
			},
			{
				path: Paths.GAMES_EDIT,
				name: Names.GAMES_EDIT,
				meta:{

					key: Names.GAMES,
				},
				component: () => import('@/pages/FormPage.vue'),
				props: {key:  Names.GAMES_EDIT}
			},
			{
				path: Paths.MISSIONS,
				name: Names.MISSIONS,
				meta:{

					key: Names.MISSIONS,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.MISSIONS}
			},
			{
				path: Paths.TRANSACTIONS,
				name: Names.TRANSACTIONS,
				meta:{

					key: Names.TRANSACTIONS,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.MISSIONS}
			},
			{
				path: Paths.PURCHASES,
				name: Names.PURCHASES,
				meta:{

					key: Names.PURCHASES,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.PURCHASES}
			},
			{
				path: Paths.MISSIONS_ADD,
				name: Names.MISSIONS_ADD,
				meta:{

					key: Names.MISSIONS,
				},
				component: () => import('@/pages/FormPage.vue'),
				props: {key:  Names.MISSIONS_ADD}
			},
			{
				path: Paths.MISSIONS_EDIT,
				name: Names.MISSIONS_EDIT,
				meta:{

					key: Names.MISSIONS,
				},
				component: () => import('@/pages/FormPage.vue'),
				props: {key:  Names.MISSIONS_EDIT}
			},
			{
				path: Paths.USERS,
				name: Names.USERS,
				meta:{
					key: Names.USERS,
					
				},
				component: () => import('@/pages/ListPage.vue'),
			},
			
			{
				path: Paths.USERS_ADD,
				name: Names.USERS_ADD,
				meta:{
					key: Names.USERS,
					
				},
				component: () => import('@/pages/FormPage.vue'),
			},
			{
				path: Paths.USERS_EDIT,
				name: Names.USERS_EDIT,
				meta:{
					key: Names.USERS,
					
				},
				component: () => import('@/pages/FormPage.vue'),
			},
			{
				path: Paths.USERS_ACTIVITY,
				name: Names.USERS_ACTIVITY,
				meta: {
					key: Names.USERS,
				},
				component: () => import('@/pages/users/UserActivityPage.vue'),
			},
			{
				path: Paths.COUNTRIES,
				name: Names.COUNTRIES,
				meta:{

					key: Names.COUNTRIES,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.COUNTRIES}
			},
			{
				path: Paths.BETTING_COMPANIES,
				name: Names.BETTING_COMPANIES,
				meta:{

					key: Names.BETTING_COMPANIES,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.BETTING_COMPANIES}
			},
			{
				path: Paths.COUNTRIES_ADD,
				name: Names.COUNTRIES_ADD,
				meta:{

					key: Names.COUNTRIES,
				},
				component: () => import('@/pages/FormPage.vue'),
				
			},
			{
				path: Paths.BETTING_COMPANIES_ADD,
				name: Names.BETTING_COMPANIES_ADD,
				meta:{

					key: Names.BETTING_COMPANIES,
				},
				component: () => import('@/pages/FormPage.vue'),
				
			},
			{
				path: Paths.COUNTRIES_EDIT,
				name: Names.COUNTRIES_EDIT,
				meta:{

					key: Names.COUNTRIES,
				},
				component: () => import('@/pages/FormPage.vue'),
				
			},
			{
				path: Paths.BETTING_COMPANIES_EDIT,
				name: Names.BETTING_COMPANIES_EDIT,
				meta:{

					key: Names.BETTING_COMPANIES,
				},
				component: () => import('@/pages/FormPage.vue'),
				
			},
			
			
			{
				path: Paths.LEAGUES_ORDER_PAGE,
				name: Names.LEAGUES_ORDER_PAGE,
				meta:{
					key: Names.LEAGUES_ORDER_PAGE,					
				},
				component: () => import('@/pages/leagues/LeaguesOrder.vue'),
			},
			
			{
				path: Paths.COUPONS,
				name: Names.COUPONS,
				meta:{
					key: Names.COUPONS,					
				},
				component: () => import('@/pages/BoxPage.vue'),
			},
			{
				path: Paths.COUPONS_EDIT,
				name: Names.COUPONS_EDIT,
				meta:{
					key: Names.COUPONS_EDIT,
				},
				component: () => import('@/pages/FormPage.vue'),
				props: {key:  Names.COUPONS_EDIT}
			},
			{
				path: Paths.COUPONS_EXPIRED,
				name: Names.COUPONS_EXPIRED,
				meta:{
					key: Names.COUPONS_EXPIRED,
				},
				component: () => import('@/pages/BoxPage.vue'),
			},
			{
				path: Paths.POINTS,
				name: Names.POINTS,
				meta:{
					key: Names.POINTS,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.POINTS}
			},
			{
				path: Paths.TOURNAMENTS,
				name: Names.TOURNAMENTS,
				meta:{
					key: Names.TOURNAMENTS,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.TOURNAMENTS}
			},
			{
				path: Paths.TOURNAMENTS_ADD,
				name: Names.TOURNAMENTS_ADD,
				meta:{
					key: Names.TOURNAMENTS,
				},
				component: () => import('@/pages/FormPage.vue'),
			},
			{
				path: Paths.TOURNAMENTS_EDIT,
				name: Names.TOURNAMENTS_EDIT,
				meta:{
					key: Names.TOURNAMENTS,
				},
				component: () => import('@/pages/FormPage.vue'),
			},
			{
				path: Paths.TOURNAMENT_POINTS,
				name: Names.TOURNAMENT_POINTS,
				meta:{
					key: Names.TOURNAMENT_POINTS,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.TOURNAMENT_POINTS}
			},
			{
				path: Paths.SPONSORS,
				name: Names.SPONSORS,
				meta:{
					key: Names.SPONSORS,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: {key:  Names.SPONSORS}
			},
			{
				path: Paths.SPONSORS_ADD,
				name: Names.SPONSORS_ADD,
				meta:{
					key: Names.SPONSORS,
				},
				component: () => import('@/pages/FormPage.vue'),
			},
			{
				path: Paths.SPONSORS_EDIT,
				name: Names.SPONSORS_EDIT,
				meta:{
					key: Names.SPONSORS,
				},
				component: () => import('@/pages/FormPage.vue'),
			},
			{
				path: Paths.FAQ,
				name: Names.FAQ,
				meta: {
					key: Names.FAQ,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: { key: Names.FAQ },
			},
			{
				path: Paths.CONTACT_FORM_REQUESTS,
				name: Names.CONTACT_FORM_REQUESTS,
				meta: {
					key: Names.CONTACT_FORM_REQUESTS,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: { key: Names.CONTACT_FORM_REQUESTS },
			},
			{
				path: Paths.REPORT_ISSUE_REQUESTS,
				name: Names.REPORT_ISSUE_REQUESTS,
				meta: {
					key: Names.REPORT_ISSUE_REQUESTS,
				},
				component: () => import('@/pages/ListPage.vue'),
				props: { key: Names.REPORT_ISSUE_REQUESTS },
			},
			{
				path: Paths.FAQ_ADD,
				name: Names.FAQ_ADD,
				meta: {
					key: Names.FAQ,
				},
				component: () => import('@/pages/FormPage.vue'),
			},
			{
				path: Paths.FAQ_EDIT,
				name: Names.FAQ_EDIT,
				meta: {
					key: Names.FAQ,
				},
				component: () => import('@/pages/FormPage.vue'),
			}
			
			
		],
	},
	{
		path: '/',
		component: () => import('@/components/page-layouts/Auth.vue'),
		children: [
			{
				path: '/sign-in',
				name: 'sign-in',
				component: () => import('@/views/crafted/authentication/basic-flow/SignIn.vue'),
			}			
		],
	},
	{
		// the 404 route, when none of the above matches
		path: '/404',
		name: '404',
		component: () => import('@/views/crafted/authentication/Error404.vue'),
	},
	{
		path: '/500',
		name: '500',
		component: () => import('@/views/crafted/authentication/Error500.vue'),
	},
	{
		path: '/:pathMatch(.*)*',
		redirect: '/404',
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

const shouldPromptUnsavedOrder = (from: any, to: any) => {
	const fromKey = from.meta?.key as string | undefined;
	if (!fromKey || to.fullPath === from.fullPath) return false;
	const hasPendingOrder = store.getters.getSortableListChanged({ key: fromKey });
	const fromMapping = store.getters.getMapping({ key: fromKey });
	const hasOrderFeature = Boolean(fromMapping?.map?.updateOrder);
	return hasPendingOrder && hasOrderFeature;
};

const promptUnsavedOrder = (next: any) => {
	Swal.fire({
		html: "<span>Are you sure you want to leave? Your changes won't be saved.</span>",
		icon: "warning",
		buttonsStyling: true,
		showCancelButton: true,
		showConfirmButton: true,
		reverseButtons: true,
		confirmButtonText: "Leave",
		cancelButtonText: "Return",
		customClass: {
			confirmButton: "btn btn-primary",
			cancelButton: "btn",
		},
	}).then((result) => {
		if (result.isConfirmed) {
			next();
		} else {
			next(false);
		}
	});
};

router.beforeEach((to, from, next) => {
	if (!to.fullPath.includes('sign-in')) {
		if (store.getters.isUserAuthenticated) {
			if(to.meta){
				if(to.meta.permission){
					if(Storage.get(to.meta.permission) || Storage.get('canAccessAllOperations')){
						if (shouldPromptUnsavedOrder(from, to)) {
							promptUnsavedOrder(next);
							return;
						}
						next();
					}
					else{
				
						next({name:'notAuthorized'});
					}
				}
				else{
					if (shouldPromptUnsavedOrder(from, to)) {
						promptUnsavedOrder(next);
						return;
					}
					next();
				}
			}
			else{
				if (shouldPromptUnsavedOrder(from, to)) {
					promptUnsavedOrder(next);
					return;
				}
				next();
			}
			
			
		} else {
			next({ name: 'sign-in' });
		}
	} else {
		next();
	}

	// Scroll page to top on every route change
	setTimeout(() => {
		window.scrollTo(0, 0);
	}, 100);
});

export default router;
